import { render, staticRenderFns } from "./zhishu.vue?vue&type=template&id=66433e35&scoped=true"
import script from "./zhishu.vue?vue&type=script&lang=js"
export * from "./zhishu.vue?vue&type=script&lang=js"
import style0 from "./zhishu.vue?vue&type=style&index=0&id=66433e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66433e35",
  null
  
)

export default component.exports